
import Swiper from 'swiper/bundle';
// import Swiper styles
// import 'swiper/css';
window.addEventListener('load', function () {

	// var swiper1 = new Swiper('.swiper-v1', {
	// 	direction: 'vertical',
	// 	slidesPerView: 2,
	// 	loop: true,
	// 	autoplay: {
	// 		delay: 0,
	// 	},
	// 	speed: 7500,
	// 	spaceBetween: 20,
	// });
	// var swiper2 = new Swiper('.swiper-v2', {
	// 	direction: 'vertical',
	// 	slidesPerView: 2,
	// 	loop: true,
	// 	autoplay: {
	// 		delay: 0,
	// 		reverseDirection: true,
	// 	},
	// 	speed: 7500,
	// 	spaceBetween: 20,
	// });
	// var swiper3 = new Swiper('.swiper-v3', {
	// 	direction: 'vertical',
	// 	slidesPerView: 2,
	// 	loop: true,
	// 	autoplay: {
	// 		delay: 0,
	// 	},
	// 	speed: 7500,
	// 	spaceBetween: 20,
	// });
	// var swiper4 = new Swiper('.swiper-v4', {
	// 	direction: 'vertical',
	// 	slidesPerView: 2,
	// 	loop: true,
	// 	autoplay: {
	// 		delay: 0,
	// 		reverseDirection: true,
	// 	},
	// 	speed: 7500,
	// 	spaceBetween: 20,
	// });



	const swiper_vertical = document.querySelectorAll(".swiper");
	let options_vertical = [];
	const commonOptions = {
		direction: 'vertical',
		slidesPerView: 2.2,
		loop: true,
		speed: 10000,
		spaceBetween: 10,
		allowTouchMove: false,
		// enabled: false,
		breakpoints: {
			768: {
				slidesPerView: 1.63,
				spaceBetween: 20,
			},
		},
	}
	for (var i = 0; i < swiper_vertical.length; i++) {
		// console.log(i);
		if (i % 2 === 0) {
			options_vertical[i] = {
				...commonOptions,
				autoplay: {
					delay: 0,
					reverseDirection: true,
				},
			}
			// console.log(options_vertical[i]);
		} else {
			options_vertical[i] = {
				...commonOptions,
				autoplay: {
					delay: 0,
					// reverseDirection: false,
				},
			}
			// console.log(options_vertical[i]);
		}
		new Swiper(swiper_vertical[i], options_vertical[i]);
	}


	//学科ブログ


	// document.addEventListener('DOMContentLoaded', function () {
	// 	let elms_blog;
	// 	// 有効化時のオプションを記述
	// 	function initializeSwiper() {
	// 		// console.log('initialize実行');
	// 		// let elms_blog = document.getElementsByClassName(".slide-blog");

	// 		// for (var i = 0; i < elms_blog.length; i++) {
	// 		// let options_blog = {
	// 		// 	loop: true,
	// 		// 	spaceBetween: 6,
	// 		// 	slidesPerView: 2,
	// 		// 	autoplay: {
	// 		// 		delay: 2000,
	// 		// 	},
	// 		// 	pagination: {
	// 		// 		el: ".swiper-pagination",
	// 		// 		clickable: true,
	// 		// 	},
	// 		// 	navigation: {
	// 		// 		nextEl: ".swiper-button-next",
	// 		// 		prevEl: ".swiper-button-prev"
	// 		// 	},
	// 		// };
	// 		// new Swiper(elms_blog, options_blog);
	// 		// };
	// 		// console.log(elms_blog);

	// 		elms_blog = new Swiper('.slide-blog', {
	// 			loop: true,
	// 			spaceBetween: 10,
	// 			slidesPerView: 2,
	// 			autoplay: {
	// 				delay: 2000,
	// 				// reverseDirection: true,
	// 			},
	// 			speed: 800,
	// 			pagination: {
	// 				el: ".swiper-pagination",
	// 				clickable: true,
	// 			},
	// 			navigation: {
	// 				nextEl: ".swiper-button-next",
	// 				prevEl: ".swiper-button-prev"
	// 			},
	// 		});
	// 	}
	// 	// 無効化する用の記述
	// 	function destroySwiper() {
	// 		// console.log('destroy実行');
	// 		// console.log(elms_blog);
	// 		if (elms_blog) {
	// 			for (var i = 0; i < elms_blog.length; i++) {
	// 				// console.log('destroy実行2');
	// 				elms_blog[i].destroy();
	// 				// elms_blog[i] = undefined;
	// 			}
	// 			// elms_blog.destroy();
	// 			elms_blog = undefined;
	// 		}
	// 	}
	// 	// if分を用いて横幅に応じて関数を実行
	// 	function handleResize() {
	// 		var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	// 		// console.log("width：" + w);
	// 		// console.log("elms_blog：" + elms_blog);
	// 		if (w <= 767) {
	// 			// console.log("768以下" + elms_blog);
	// 			if (!elms_blog) {
	// 				initializeSwiper();
	// 			}
	// 		} else {
	// 			// console.log("768以上" + elms_blog);
	// 			destroySwiper();
	// 		}
	// 	}
	// 	// 初回実行
	// 	handleResize();
	// 	window.addEventListener('resize', handleResize);
	// });


	//フッター近くのスライド
	const swiper_info_footer = new Swiper('#info-footer', {

		slidesPerView: 1.3,
		slidesPerView: 'auto',
		loop: true,
		autoplay: {
			delay: 0,
			// reverseDirection: true,
		},
		speed: 10000,
		spaceBetween: 12,
		allowTouchMove: false,
		// enabled: false,
		// virtual: {
		// 	enabled: true, // バーチャルスライドを有効にします。
		// 	addSlidesAfter: 4, // 事前にレンダリングする枚数。スライドの枚数が入ります。
		// },
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 21,
			},
			1024: {
				slidesPerView: 4,
			},
		},
	});

	//オープンキャンパス
	const state = new Swiper('.slide-state', {
		slidesPerView: 1.3,
		slidesPerView: 'auto',
		loop: true,
		autoplay: {
			delay: 0,
		},
		speed: 10000,
		spaceBetween: 20,
		allowTouchMove: false,
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 56,
			},
			// 1024: {
			// 	slidesPerView: 4,
			// 	spaceBetween: 21,
			// },
		},
	});
});
//学科紹介ページ
const student = document.querySelectorAll('.student-swiper .swiper-slide').length;
console.log(student.length);
const requiredSlidesForLoop = 3; // 必要なスライド数（例）
const initStudentSwiper = () => {
	const studentSwiper = new Swiper('.student-swiper', {
		slidesPerView: 'auto',
		spaceBetween: 16,
		// loop: true,
		loop: slides.length >= requiredSlidesForLoop,
		loopedSlides: slides.length,
		speed: 8000,
		autoplay: slides.length >= requiredSlidesForLoop ? {
			delay: 0,
			disableOnInteraction: false,
		} : false,
		loopAdditionalSlides: 3,
		freeMode: {
			enabled: true,
			momentum: false,
		},
		grabCursor: true,
		breakpoints: {
			1025: {
				spaceBetween: 32,
			}
		},
		on: {
			touchEnd: (swiper) => {
				swiper.slideTo(swiper.activeIndex + 1);
			}
		}
	});
};
window.addEventListener('load', function () {
	initStudentSwiper(); // ページ読み込み後に初期化
});

const graduateSlideLength = document.querySelectorAll('.graduate-swiper .swiper-slide').length;
const initGraduateSwiper = () => {
	const graduateSwiper = new Swiper('.graduate-swiper', {
		slidesPerView: 'auto',
		spaceBetween: 16,
		loop: true,
		loopedSlides: graduateSlideLength,
		speed: 8000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		freeMode: {
			enabled: true,
			momentum: false,
		},
		grabCursor: true,
		breakpoints: {
			1025: {
				spaceBetween: 32,
			}
		},
		on: {
			touchEnd: (swiper) => {
				swiper.slideTo(swiper.activeIndex + 1);
			}
		}
	});
};
window.addEventListener('load', function () {
	initGraduateSwiper(); // ページ読み込み後に初期化
});

// 学科紹介・スポーツメディカルコース
document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('main.sports_medical')) {
		const swiper_sports = new Swiper('.swiper_sports', {
			slidesPerView: 'auto',
			spaceBetween: 8,
			freeMode: false,
			speed: 10000,
			loopFillGroupWithBlank: true,
			loopedSlides: 3,
			loop: true,
			autoplay: {
				delay: 0,
			},
		});
	}
});
window.addEventListener('load', function () {
	if (document.querySelector('.area-slide')) {
		const swiper_sports = new Swiper('.swiper_sports', {
			slidesPerView: 'auto',
			spaceBetween: 8,
			freeMode: false,
			speed: 10000,
			loopFillGroupWithBlank: true,
			loopedSlides: 3,
			loop: true,
			autoplay: {
				delay: 0,
			},
		});
	}
});